// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea_textarea__PfqxV","otherContract":"Textarea_otherContract__w-Y4L"};